<template>
    <component :is="buttonType"
               :disabled="trimEditDisabled"
               title="Save: Ctrl+S"
               @click="saveTrim"
    >
        <i v-if="!isSaving" class="icon-floppy"></i>
        <i v-else class="icon-spin4 animate-spin"></i>
        {{ buttonType === 'Button' ? 'Save' : '' }}
    </component>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";
    import Button from "../../components/Button";

    export default {
        name: "SaveTrim",

        components: {
            Button,
            ButtonCircle,
        },

        emits: [
            'saved',
        ],

        props: [
            'buttonType',
        ],

        data() {
            return {
                isSaving: false,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

        },

        methods: {
            ...mapActions('trims', [
                'saveTrimFromEditor',
            ]),

            async saveTrim() {
                if (this.isSaving || this.trimEditDisabled) return;

                // this variables are use for indicate saving process
                this.isSaving = true;
                let isSaved = false;
                let timeIsOut = false;

                setTimeout(() => {
                    timeIsOut = true;

                    if (isSaved) {
                        this.saved();
                    }
                }, 1000);

                await this.saveTrimFromEditor();

                isSaved = true;

                if (timeIsOut) {
                    this.saved();
                }
            },

            saved() {
                this.isSaving = false;

                this.$emit('saved');
            },

            keyDown(e) {
                const isCtrl = e.ctrlKey;
                const keyCode = e.code;

                if(isCtrl && keyCode === 'KeyS') {
                    e.preventDefault();

                    this.saveTrim();

                    return false;
                }
            },

        },

        beforeMount() {
            window.addEventListener("keydown", this.keyDown, false)
        },

        beforeUnmount() {
            window.removeEventListener("keydown", this.keyDown);
        },

    }
</script>

<style scoped>

</style>